// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * The following are shared across all platforms and apps
 */
.forms-mgmt-page {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  padding: 1.5rem 1rem 2rem;
  color: #3d5a80;
}

.forms-mgmt-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(180deg, #fafcfe 0%, #f0f5fb 100%);
  border: 1px solid #bfd4ec;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.forms-mgmt-toolbar__intro {
  flex: 1 1 auto;
  min-width: 0;
}
.forms-mgmt-toolbar__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #3d5a80;
  letter-spacing: -0.02em;
}
.forms-mgmt-toolbar__actions {
  flex-shrink: 0;
}
.forms-mgmt-toolbar__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.forms-mgmt-toolbar__btn-text {
  font-weight: 600;
}
.forms-mgmt-toolbar__btn-icon {
  margin: 0;
}

.forms-mgmt-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2.5rem 1.5rem;
  text-align: center;
  border: 1px dashed #bfd4ec;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.85);
  color: #5c6570;
}
.forms-mgmt-empty__icon {
  font-size: 2.25rem;
  opacity: 0.45;
}
.forms-mgmt-empty__text {
  margin: 0;
  font-size: 1rem;
}

.forms-mgmt-panel {
  border: 1px solid #bfd4ec;
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;
  overflow-x: auto;
  box-shadow: 0 1px 4px rgba(30, 64, 120, 0.06);
}

/* Tabla: cabeceras y celdas comparten columnas (alineación fiable) */
.forms-mgmt-table-wrap {
  width: 100%;
  min-width: 58.25rem;
}

.forms-mgmt-table {
  width: 100%;
  margin: 0;
  border-collapse: collapse;
  table-layout: fixed;
}

.forms-mgmt-thead th {
  vertical-align: bottom;
  padding: 0.55rem 0.75rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5c6570;
  background: #eef3f9;
  border-bottom: 1px solid #bfd4ec;
}

.forms-mgmt-th--default-col,
.forms-mgmt-td--default-col {
  width: 4.5rem;
  text-align: center;
}

.forms-mgmt-th--enabled-col,
.forms-mgmt-td--enabled-col {
  width: 8.5rem;
  text-align: center;
}

.forms-mgmt-th--enabled-col .forms-mgmt-th__label {
  display: block;
  max-width: 8rem;
  margin: 0 auto;
  line-height: 1.25;
  hyphens: auto;
}

.forms-mgmt-th--type,
.forms-mgmt-td--type {
  width: 9rem;
  text-align: left;
}

.forms-mgmt-th--actions,
.forms-mgmt-td--actions {
  width: 26rem;
  text-align: right;
}

.forms-mgmt-th--report,
.forms-mgmt-td--report {
  text-align: left;
}

.forms-mgmt-td {
  padding: 0.55rem 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid #e8eef5;
}

.forms-mgmt-tr:last-child .forms-mgmt-td {
  border-bottom: none;
}

.forms-mgmt-tr:not(.forms-mgmt-tr--confirm):hover .forms-mgmt-td {
  background: #fafcfe;
}

.forms-mgmt-tr--confirm .forms-mgmt-td {
  background: #fffbf0;
  box-shadow: inset 0 0 0 1px rgba(245, 158, 11, 0.35);
}

@media (max-width: 767.98px) {
  .forms-mgmt-thead {
    display: none;
  }
  .forms-mgmt-table-wrap {
    min-width: 36rem;
  }
}
.forms-mgmt-report-name {
  display: block;
  width: 100%;
  min-width: 0;
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #3d5a80;
  border-radius: 6px;
  border: 1px solid transparent;
  box-sizing: border-box;
  word-break: break-word;
}
.forms-mgmt-report-name--predeterminado {
  border-color: rgba(74, 138, 212, 0.35);
  border-left: 3px solid var(--undp-jtf-accent-color, #4a8ad4);
  padding-left: calc(0.75rem - 2px);
  background: rgba(74, 138, 212, 0.06);
}

.forms-mgmt-enable-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0.26rem 0.55rem;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-transform: none;
  border-radius: 999px;
  border-width: 1.5px;
  box-shadow: none;
}
.forms-mgmt-enable-btn__icon {
  flex-shrink: 0;
  font-size: 0.82rem;
  line-height: 1;
}
.forms-mgmt-enable-btn__label {
  flex: 1 1 auto;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.forms-mgmt-enable-btn.btn-outline-success {
  color: #0f5132;
  border-color: #198754;
  background: rgba(25, 135, 84, 0.06);
}
.forms-mgmt-enable-btn.btn-outline-success:hover, .forms-mgmt-enable-btn.btn-outline-success:focus {
  color: #fff;
  background: #198754;
  border-color: #198754;
}
.forms-mgmt-enable-btn.btn-outline-danger {
  color: #842029;
  border-color: #dc3545;
  background: rgba(220, 53, 69, 0.06);
}
.forms-mgmt-enable-btn.btn-outline-danger:hover, .forms-mgmt-enable-btn.btn-outline-danger:focus {
  color: #fff;
  background: #dc3545;
  border-color: #dc3545;
}

.forms-mgmt-type-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  max-width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  padding: 0 0.55rem;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  color: #3d5a80;
  background: #fff;
  border: 1px solid #c5d4e8;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.forms-mgmt-default {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  margin: 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  min-height: 2.5rem;
}

.forms-mgmt-default__input {
  flex-shrink: 0;
  width: 1.1rem;
  height: 1.1rem;
  margin: 0;
  cursor: pointer;
  accent-color: var(--undp-jtf-accent-color, #2563eb);
}

.forms-mgmt-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

@media (min-width: 992px) {
  .forms-mgmt-actions {
    flex-wrap: nowrap;
  }
}
.forms-mgmt-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  font-weight: 600;
}
.forms-mgmt-action-btn--wide {
  min-width: 7rem;
}

@media (max-width: 576px) {
  .forms-mgmt-toolbar__actions {
    width: 100%;
    display: flex;
  }
  .forms-mgmt-toolbar__actions .btn {
    flex: 1;
  }
  .forms-mgmt-action-btn {
    flex: 1 1 calc(50% - 0.2rem);
    justify-content: center;
    min-width: 0;
  }
  .forms-mgmt-action-btn span {
    max-width: none;
  }
  .forms-mgmt-action-btn--wide {
    flex: 1 1 100%;
  }
}
.forms-mgmt-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  border-bottom: 1px solid #e8eef5;
}
.forms-mgmt-modal__header .modal-title {
  font-weight: 700;
  color: #3d5a80;
  padding-right: 0.5rem;
}
.forms-mgmt-modal__header .close {
  flex-shrink: 0;
  margin: 0;
  padding: 0.5rem;
}

.forms-mgmt-modal__body {
  padding-top: 1rem;
}

.forms-mgmt-modal__lead {
  margin: 0 0 1rem;
  padding: 0.6rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #5c6570;
  background: #f4f7fb;
  border: 1px solid #e2eaf4;
  border-radius: 6px;
}

.forms-mgmt-modal__form {
  max-width: 100%;
}

.forms-mgmt-modal__label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #3d5a80;
  margin-bottom: 0.35rem;
}

.forms-mgmt-modal__footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.25rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eef2f7;
}

.font-style-italic {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/forms-page/components/forms-page.component.scss","webpack://./libs/scss/_index.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADOA;EACE,sBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,cAPc;AAKhB;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;AAFF;AAIE;EACE,cAAA;EACA,YAAA;AAFJ;AAKE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAhCY;EAiCZ,uBAAA;AAHJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAQE;EACE,gBAAA;AANJ;AASE;EACE,SAAA;AAPJ;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,qCAAA;EACA,cAnEY;AA2Dd;AAUE;EACE,kBAAA;EACA,aAAA;AARJ;AAWE;EACE,SAAA;EACA,eAAA;AATJ;;AAaA;EACE,yBAAA;EACA,mBAAA;EACA,mBApFc;EAqFd,gBAAA;EACA,gBAAA;EACA,6CAAA;AAVF;;AAaA,qEAAA;AACA;EACE,WAAA;EACA,mBAAA;AAVF;;AAaA;EACE,WAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cA7GY;EA8GZ,mBAAA;EACA,gCAAA;AAVF;;AAaA;;EAEE,aAAA;EACA,kBAAA;AAVF;;AAaA;;EAEE,aAAA;EACA,kBAAA;AAVF;;AAaA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;AAVF;;AAaA;;EAEE,WAAA;EACA,gBAAA;AAVF;;AAaA;;EAEE,YAAA;EACA,iBAAA;AAVF;;AAaA;;EAEE,gBAAA;AAVF;;AAaA;EACE,wBAAA;EACA,sBAAA;EACA,gCAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,oDAAA;AAVF;;AAaA;EACE;IACE,aAAA;EAVF;EAaA;IACE,gBAAA;EAXF;AACF;AAcA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cA3Lc;EA4Ld,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;AAZF;AAcE;EACE,sCAAA;EACA,4DAAA;EACA,iCAAA;EACA,oCAAA;AAZJ;;AAgBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAbF;AAeE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AAbJ;AAgBE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,qBAAA;EACA,mCAAA;AAfJ;AAgBI;EAEE,WAAA;EACA,mBAAA;EACA,qBAAA;AAfN;AAmBE;EACE,cAAA;EACA,qBAAA;EACA,mCAAA;AAjBJ;AAkBI;EAEE,WAAA;EACA,mBAAA;EACA,qBAAA;AAjBN;;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cA/Qc;EAgRd,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,mDAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAnBF;;AAsBA;EACE;IACE,iBAAA;EAnBF;AACF;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AApBF;AAsBE;EACE,eAAA;AApBJ;;AAwBA;EACE;IACE,WAAA;IACA,aAAA;EArBF;EAuBE;IACE,OAAA;EArBJ;EAyBA;IACE,4BAAA;IACA,uBAAA;IACA,YAAA;EAvBF;EAyBE;IACE,eAAA;EAvBJ;EA2BA;IACE,cAAA;EAzBF;AACF;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,gCAAA;AA1BF;AA4BE;EACE,gBAAA;EACA,cA1WY;EA2WZ,qBAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,SAAA;EACA,eAAA;AA3BJ;;AA+BA;EACE,iBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cA/XY;EAgYZ,mBAAA;EACA,yBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,eAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cA5Yc;EA6Yd,sBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;AA5BF;;AA+BA;EACE,kBAAA;AA5BF","sourcesContent":["@import \"../../../../scss/variables\";\n\n$forms-border: #bfd4ec;\n$forms-surface: #ffffff;\n$forms-muted: #5c6570;\n$forms-heading: #3d5a80;\n\n.forms-mgmt-page {\n  box-sizing: border-box;\n  max-width: 100%;\n  min-width: 0;\n  padding: 1.5rem 1rem 2rem;\n  color: $forms-heading;\n}\n\n.forms-mgmt-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: linear-gradient(180deg, #fafcfe 0%, #f0f5fb 100%);\n  border: 1px solid $forms-border;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n\n  &__intro {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: $forms-heading;\n    letter-spacing: -0.02em;\n  }\n\n  &__actions {\n    flex-shrink: 0;\n  }\n\n  &__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n  }\n\n  &__btn-text {\n    font-weight: 600;\n  }\n\n  &__btn-icon {\n    margin: 0;\n  }\n}\n\n.forms-mgmt-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  border: 1px dashed $forms-border;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.85);\n  color: $forms-muted;\n\n  &__icon {\n    font-size: 2.25rem;\n    opacity: 0.45;\n  }\n\n  &__text {\n    margin: 0;\n    font-size: 1rem;\n  }\n}\n\n.forms-mgmt-panel {\n  border: 1px solid $forms-border;\n  border-radius: 10px;\n  background: $forms-surface;\n  overflow: hidden;\n  overflow-x: auto;\n  box-shadow: 0 1px 4px rgba(30, 64, 120, 0.06);\n}\n\n/* Tabla: cabeceras y celdas comparten columnas (alineación fiable) */\n.forms-mgmt-table-wrap {\n  width: 100%;\n  min-width: 58.25rem;\n}\n\n.forms-mgmt-table {\n  width: 100%;\n  margin: 0;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.forms-mgmt-thead th {\n  vertical-align: bottom;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $forms-muted;\n  background: #eef3f9;\n  border-bottom: 1px solid $forms-border;\n}\n\n.forms-mgmt-th--default-col,\n.forms-mgmt-td--default-col {\n  width: 4.5rem;\n  text-align: center;\n}\n\n.forms-mgmt-th--enabled-col,\n.forms-mgmt-td--enabled-col {\n  width: 8.5rem;\n  text-align: center;\n}\n\n.forms-mgmt-th--enabled-col .forms-mgmt-th__label {\n  display: block;\n  max-width: 8rem;\n  margin: 0 auto;\n  line-height: 1.25;\n  hyphens: auto;\n}\n\n.forms-mgmt-th--type,\n.forms-mgmt-td--type {\n  width: 9rem;\n  text-align: left;\n}\n\n.forms-mgmt-th--actions,\n.forms-mgmt-td--actions {\n  width: 26rem;\n  text-align: right;\n}\n\n.forms-mgmt-th--report,\n.forms-mgmt-td--report {\n  text-align: left;\n}\n\n.forms-mgmt-td {\n  padding: 0.55rem 0.75rem;\n  vertical-align: middle;\n  border-bottom: 1px solid #e8eef5;\n}\n\n.forms-mgmt-tr:last-child .forms-mgmt-td {\n  border-bottom: none;\n}\n\n.forms-mgmt-tr:not(.forms-mgmt-tr--confirm):hover .forms-mgmt-td {\n  background: #fafcfe;\n}\n\n.forms-mgmt-tr--confirm .forms-mgmt-td {\n  background: #fffbf0;\n  box-shadow: inset 0 0 0 1px rgba(245, 158, 11, 0.35);\n}\n\n@media (max-width: 767.98px) {\n  .forms-mgmt-thead {\n    display: none;\n  }\n\n  .forms-mgmt-table-wrap {\n    min-width: 36rem;\n  }\n}\n\n.forms-mgmt-report-name {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  min-height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: $forms-heading;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  box-sizing: border-box;\n  word-break: break-word;\n\n  &--predeterminado {\n    border-color: rgba(74, 138, 212, 0.35);\n    border-left: 3px solid var(--undp-jtf-accent-color, #4a8ad4);\n    padding-left: calc(0.75rem - 2px);\n    background: rgba(74, 138, 212, 0.06);\n  }\n}\n\n.forms-mgmt-enable-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0.26rem 0.55rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  border-radius: 999px;\n  border-width: 1.5px;\n  box-shadow: none;\n\n  &__icon {\n    flex-shrink: 0;\n    font-size: 0.82rem;\n    line-height: 1;\n  }\n\n  &__label {\n    flex: 1 1 auto;\n    min-width: 0;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &.btn-outline-success {\n    color: #0f5132;\n    border-color: #198754;\n    background: rgba(25, 135, 84, 0.06);\n    &:hover,\n    &:focus {\n      color: #fff;\n      background: #198754;\n      border-color: #198754;\n    }\n  }\n\n  &.btn-outline-danger {\n    color: #842029;\n    border-color: #dc3545;\n    background: rgba(220, 53, 69, 0.06);\n    &:hover,\n    &:focus {\n      color: #fff;\n      background: #dc3545;\n      border-color: #dc3545;\n    }\n  }\n}\n\n.forms-mgmt-type-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  max-width: 100%;\n  min-height: calc(1.5em + 0.75rem + 2px);\n  padding: 0 0.55rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25;\n  color: $forms-heading;\n  background: #fff;\n  border: 1px solid #c5d4e8;\n  border-radius: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.forms-mgmt-default {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.2rem;\n  margin: 0;\n  cursor: pointer;\n  user-select: none;\n  min-height: 2.5rem;\n}\n\n.forms-mgmt-default__input {\n  flex-shrink: 0;\n  width: 1.1rem;\n  height: 1.1rem;\n  margin: 0;\n  cursor: pointer;\n  accent-color: var(--undp-jtf-accent-color, #2563eb);\n}\n\n.forms-mgmt-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .forms-mgmt-actions {\n    flex-wrap: nowrap;\n  }\n}\n\n.forms-mgmt-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  font-weight: 600;\n\n  &--wide {\n    min-width: 7rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .forms-mgmt-toolbar__actions {\n    width: 100%;\n    display: flex;\n\n    .btn {\n      flex: 1;\n    }\n  }\n\n  .forms-mgmt-action-btn {\n    flex: 1 1 calc(50% - 0.2rem);\n    justify-content: center;\n    min-width: 0;\n\n    span {\n      max-width: none;\n    }\n  }\n\n  .forms-mgmt-action-btn--wide {\n    flex: 1 1 100%;\n  }\n}\n\n.forms-mgmt-modal__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  border-bottom: 1px solid #e8eef5;\n\n  .modal-title {\n    font-weight: 700;\n    color: $forms-heading;\n    padding-right: 0.5rem;\n  }\n\n  .close {\n    flex-shrink: 0;\n    margin: 0;\n    padding: 0.5rem;\n  }\n}\n\n.forms-mgmt-modal__body {\n  padding-top: 1rem;\n}\n\n.forms-mgmt-modal__lead {\n  margin: 0 0 1rem;\n  padding: 0.6rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: $forms-muted;\n  background: #f4f7fb;\n  border: 1px solid #e2eaf4;\n  border-radius: 6px;\n}\n\n.forms-mgmt-modal__form {\n  max-width: 100%;\n}\n\n.forms-mgmt-modal__label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: $forms-heading;\n  margin-bottom: 0.35rem;\n}\n\n.forms-mgmt-modal__footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 1.25rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid #eef2f7;\n}\n\n.font-style-italic {\n  font-style: italic;\n}\n","/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
